// MainLayout.js
import React, { useState, useEffect, useCallback } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

export default function MainLayout() {
  const location = useLocation();
  
  // Desktop: collapsed (icons only) vs expanded
  const [collapsed, setCollapsed] = useState(() => {
    try {
      const saved = localStorage.getItem('sidebarCollapsed');
      return saved !== null ? JSON.parse(saved) : false;
    } catch { return false; }
  });

  // Mobile: overlay open vs closed
  const [mobileOpen, setMobileOpen] = useState(false);

  // Save collapsed state
  useEffect(() => {
    try { localStorage.setItem('sidebarCollapsed', JSON.stringify(collapsed)); } catch {}
  }, [collapsed]);

  // Close mobile sidebar on route change
  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  // Close mobile sidebar when resizing to desktop
  useEffect(() => {
    const handleResize = () => { if (window.innerWidth > 768) setMobileOpen(false); };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleCollapsed = useCallback(() => setCollapsed(p => !p), []);
  const toggleMobile = useCallback(() => setMobileOpen(p => !p), []);
  const closeMobile = useCallback(() => setMobileOpen(false), []);

  return (
    <>
      <style>{`
        .layout {
          display: flex;
          min-height: 100vh;
        }
        .main-content {
          flex: 1;
          padding: 20px;
          min-height: 100vh;
          transition: margin-left 0.3s ease;
        }
        .main-content.sidebar-expanded {
          margin-left: 250px;
        }
        .main-content.sidebar-collapsed {
          margin-left: 64px;
        }
        @media (max-width: 768px) {
          .main-content {
            margin-left: 0 !important;
          }
        }
      `}</style>

      <div className="layout">
        <Sidebar 
          collapsed={collapsed}
          mobileOpen={mobileOpen}
          onCloseMobile={closeMobile}
          onToggleCollapsed={toggleCollapsed}
        />
        <div className={`main-content ${collapsed ? 'sidebar-collapsed' : 'sidebar-expanded'}`}>
          <Header onToggleSidebar={toggleMobile} />
          <Outlet />
        </div>
      </div>
    </>
  );
}